export const stepsData: string[] = [
  "Basic Details",
  "Company Details",
  "Company Type",
];
